import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Cards, NavAndTabs } from "../../components";
import { VscStarFull } from "react-icons/vsc";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../redux/actions";
import { GrLocation } from "react-icons/gr";
import MedicalTreatments from "./medicalTreatments";
import Specialist from "./specialist";

const ClinicDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const clinicData = location.state?.clinic;

  const [credentials, setCredentials] = useState({
    appDate: new Date().toISOString().split("T")[0],
    appointmentType: 2,
    LanguageIds: clinicData?.languageId[0],
    userType: 2,
    userTimeZone: "India Standard Time",
    currency: clinicData?.currency,
    clinicGuid: clinicData?.clinicGuid,
    IsClinicSchedule: true,
  });
  const [activeTab, setActiveTab] = useState(id || "medical-treatments");

  useEffect(() => {
    dispatch(actionDoctor.postSearchClinicAppointment(credentials));
  }, [credentials, dispatch]);

  const postSearchClinicAppointmentData = useSelector(
    (state) => state.doctor.postSearchClinicAppointmentData?.data
  );

  const onTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`/clinic-details/${tabId}`, {
      state: {
        clinic: clinicData,
      },
    });
  };
  const tabs = [
    {
      id: "medical-treatments",
      label: t("medical_treatments"),
      content: <MedicalTreatments />,
      disabled: false,
    },
    {
      id: "specialist",
      label: t("specialist"),
      content: <Specialist />,
      disabled: false,
    },
  ];
  return (
    <Container className="exado-container" fluid>
      <Row className="exado-row">
        <Col className="exado-col">
          <Cards.HCardd
            className="Hcardd1 custom-cursor-pointer "
            colClassNameImg="col-md-2"
            colClassNameImg1="col-md-10"
            imageSrc={
              postSearchClinicAppointmentData?.result?.clinicInfo?.clinicImage
            }
            cardBody={
              <>
                <aside className="clinic-aside ">
                  <div>
                    <div className="clinic-name-location">
                      <h3 className="exado-title-three clinic-name">
                        {/* {clinic?.clinicName} */}
                      </h3>
                      <div className="exado-title-six">
                        <VscStarFull className="clinic-star me-2" />
                        <span className="clinic-rating">
                          {
                            postSearchClinicAppointmentData?.result?.clinicInfo
                              ?.rating
                          }
                        </span>
                        <span className="clinic-review">
                          {
                            postSearchClinicAppointmentData?.result?.reviews
                              ?.length
                          }{" "}
                          {t("review")}
                        </span>
                      </div>
                    </div>
                    <div className="exado-title-six clinic-location">
                      <GrLocation className="me-2" />
                      {/* <span>{clinic?.location}</span> */}
                    </div>
                    <div className="about-blk">
                      <h5 className="exado_body_text_three">
                        {t("about_clinic")}
                      </h5>
                      <p className="exado-title-six about-description">
                        Welcome to the MedOzon Clinic, specialists in
                        regenerative therapies, oxygen-ozone therapy. We are
                        proud to present you with an oasis of health and
                        healing, where we emphasize innovation, medical
                        expertise, and personalized treatments to help you
                        regain your health and well-being. Our team consists of
                        prestigious doctors and therapists specialized in
                        medical rehabilitation and regenerative medicine. With
                        over 17 years of experience behind us, and with an
                        unwavering commitment to excellence, we are dedicated to
                        providing you with the best solutions for your medical
                        needs.
                      </p>
                    </div>
                  </div>
                </aside>

                {/*
                                                  <aside className="aside rside">
                                                      <AllAvailability.AvailabilitySlotList
                                                          availableSlot={availableSlotsMap[doctor.doctorGuid] || doctor.availableSlots}
                                                          onPerClick={() => handleAvailability(doctor.doctorGuid, -1)}
                                                          // onTimeClick={(time) => handleDateChange(time, true)}
                                                          onNextClick={() => handleAvailability(doctor.doctorGuid, 1)}
                                                      />
                                                      <div className="d-flex justify-content-end">
                                                          <Buttton.Buttton
                                                              type="button"
                                                              className="transparent"
                                                              onClick={() => {
                                                                  const today = new Date();
                                                                  const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
                                                                  const formattedDate = localDate.toISOString().split("T")[0];
              
                                                                  // Uncomment and adjust if you want to use it
                                                                  // setCredentialsSpecialist(prev => ({
                                                                  //     ...prev,
                                                                  //     appDate: formattedDate,
                                                                  // }));
                                                              }}
                                                          >
                                                              {t("view_avaiability")} <FaCaretRight />
                                                          </Buttton.Buttton>
                                                      </div>
                                                  </aside> */}
              </>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col className="exado-col">
          <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ClinicDetails;
